
//---- Description : Notification center ----//
//---- Contact : kevin.deffontaine@facilitatrip.com ----//

import { enqueueSnackbar } from "notistack";

export default function (message, $option) {
    enqueueSnackbar(message, { variant: 'warning' });
}
